module.exports = __webpack_public_path__ + "static/media/Regime.8eca0a97.jpg";